// Fulfilment cost helpers, moved as-is from Orders.jsx; used by the Orders
// page (cost details pop-up) and the Fulfilment cell.

export const calculateTotalAdditionalCost = (data) => {
  let totalCost = 0;
  if (data?.additional_costs?.length > 0) {
    data.additional_costs.forEach((currentItem) => {
      const cost = parseFloat(currentItem.cost);
      totalCost += cost;
    });
  }
  return totalCost;
};

export const calculateTotalCost = (data) => {
  let totalCost = 0;
  let total = 0;
  if (data?.additional_costs?.length > 0) {
    data.additional_costs.forEach((currentItem) => {
      const cost = parseFloat(currentItem.cost ?? 0);
      totalCost += cost;
    });
  }
  total = totalCost + parseFloat(data.fulfillment_cost ?? 0);
  return parseFloat(total).toFixed(2);
};
